import {PosInitData} from 'tplus-poslogin';
import {tools} from 'tplus-components-touch';
import localTools from './tools.js';
import {DistributionMode} from '../commom/Enum';

var activeEl_global;
class Common{
    //获取是否自提状态
    static getIsTakeTheir(dataModel) {
        let isPickUp = false;
        let dto = dataModel;
        if (dto.DistributionMode
          && DistributionMode.Code_02 == (dto.DistributionMode.Id + '')) {
          isPickUp = true;
        }
        return isPickUp;
      }
    //获取是否有更新quantity的权限
    static getIsModifyQuantityAuth(){
      const functionAuth=PosInitData("FunctionAuth")
      let isModifyQuantity=true;
      if( Array.isArray(functionAuth) ){
        isModifyQuantity=functionAuth.includes('UpdateQuantity') ;
      }
      return isModifyQuantity;
    }
    //input 输入长度，位数，限制
    static getInputLimit(key){
        var maxLength=8,precisionLength=2;
        switch (key){
            case "amount":
                maxLength=PosInitData("AmountMaxLength");
                precisionLength= PosInitData("AmountPrecision");
            break;
            case 'discount':
                maxLength=PosInitData("DiscountMaxLength");
                precisionLength= PosInitData("DiscountPrecision");
            break;
            case 'price':
                maxLength=PosInitData("PriceMaxLength");
                precisionLength= PosInitData("PricePrecision");
            break;
            case 'quantity':
                maxLength=PosInitData("QuantityMaxLength");
                precisionLength= PosInitData("QuantityPrecision");
            break;
        }
        return {maxLength,precisionLength};
    }
    //是否退货
    static getIsReturn(dataModal){
        return dataModal.IdbusiType===35;
    }
    //打印权限
    static getRepeatPrint(){
        let functionAuth = PosInitData('FunctionAuth') ;
        if( Array.isArray(functionAuth) ){
            return functionAuth.includes('RepeatPrint')
        }
        return true;
    }
    //dto明细 format
    static formatValue(field,value){
        
        if(localTools.isNull(value) || localTools.isNull(field) ){
            return null
        }
        if('Format' in field && field.Format=='Percent'){
            let key=field.Format
            if(key!==null)value=value*100+"%"
        }
        if(field['Precision'] && field.Precision){
            let key=field.Precision;
            if(key!==null)value=localTools.formatPrecision(value,key)
        }
        if('Format' in field && field.FieldType=='date'){
            let dateFormat=field.Format;
            if (value instanceof String) {
                value=String.StringToDate(value);
            }
            if (value &&value.Format) {
                return value.Format(dateFormat);
            }
            else
            {
                return tools.dateFormat(value,dateFormat);
            }
        }
        return value;
    }

    static activeEl(e){
        // if(e.srcTargetE)
        console.log('elclick.e',e)
        if(e.srcElement.tagName == 'INPUT')return;
        console.log('el.click======start')
                console.log('activeObject_document.activeElement:', document.activeElement)
                if(!activeEl_global)activeEl_global=document.querySelector(".active-el");
                if (document.activeElement == activeEl_global) return;
                activeEl_global.focus();
                console.log('activeObject',activeEl_global)
                console.log('activeObject_document.activeElement2:', document.activeElement)
        console.log('el.click======end')
    }

    static setFocus(activeEl){
        activeEl=activeEl||document.querySelector(".active-el");
        activeEl.focus();
        activeEl_global=activeEl;
    }
}
export default Common;
